/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './putPreferencesV2.defs'
export { main as default } from './putPreferencesV2.defs'
